import {ReasonType, ReasonTypeType} from './reasonType'

/** 쿠폰 선택 불가 case */
export const CouponFailReasons: ReasonTypeType[] = [
    ReasonType.DUPLICATED_SELECTED_PRODUCT_COUPON,
    ReasonType.INVALID_SELECTED_PRODUCT_DISCOUNT,
    ReasonType.INVALID_SELECTED_PRODUCT_COUPON,
    ReasonType.INVALID_SELECTED_IMMEDIATE_DISCOUNT,
    ReasonType.DUPLICATED_SELECTED_DELIVERY_FEE_COUPON,
    ReasonType.INVALID_SELECTED_DELIVERY_FEE_COUPON,
    ReasonType.DUPLICATED_SELECTED_STORE_COUPON,
    ReasonType.INVALID_SELECTED_STORE_COUPON,
]

/**
 * 배송지 변경 오류 안내 case
 * - 배송비 재조회할 때 alert
 * - 결제할 때 구매불가 이동(팝업)
 */
export const DeliveryFailReasons: ReasonTypeType[] = [
    // 상품정보가 변경되어 구매가 불가능합니다. 새로고침 후 다시 시도해주세요.
    ReasonType.DELIVERY_ATTRIBUTE_CHANGE,
    // 재고가 부족하여 결제가 불가합니다.
    ReasonType.FAILED_CHECK_PRODUCT_STOCK_QUANTITY,
    // 선택한 주소는 네이버도착보장 상품의 구매가 불가능한 주소입니다. 다른 주소를 선택해주세요.
    ReasonType.FAILED_CHECK_PRODUCT_STOCK_DELIVERY_ADDRESS,
    // 해당 네이버도착보장 상품의 여러 옵션 상품을 한번에 구매할 수 없습니다.
    ReasonType.FAILED_CHECK_PRODUCT_STOCK_DELIVERY_BUNDLE_GROUP_BY_OPTION,
    // 해당 네이버 도착보장 상품은 여러 옵션을 한번에 구매할 수 없습니다. 한 개의 옵션만 다시 선택해주세요.
    ReasonType.FAIL_DELIVERY_BUNDLE,
    // 도착보장 서비스가 불가능한 지역입니다.
    ReasonType.FAIL_ADDRESS,
    // 현재 해당 상품을 구매할 수 없습니다. 상품 정보를 다시 확인해주세요.
    ReasonType.FAILED_CHECK_PRODUCT_STOCK_DELIVERY_PLAN,
    // 현재 해당 상품을 구매할 수 없습니다. 상품 정보를 다시 확인해주세요.
    ReasonType.FAILED_CHECK_PRODUCT_STOCK_ERROR,
    // 현재 해당 상품을 구매할 수 없습니다. 상품 정보를 다시 확인해주세요.
    ReasonType.FAILED_CHECK_PRODUCT_STOCK_PRICE,
    // 구매 불가 상품 - 배송정보 변경
    ReasonType.FAIL_OUTBOUND_LOCATION,
    // 구매 불가 상품 - 배송정보 변경
    ReasonType.DELIVERY_COMPANY_CHANGE,
]

/** 배송지 변경 시 얼럿만 띄우는 케이스 */
export const DeliveryFailAlertReasons: ReasonTypeType[] = [
    ...DeliveryFailReasons,
    // 서비스 문제로 현재 구매가 불가합니다. 잠시 후 다시 시도해주세요.
    ReasonType.FAILED_CHECK_PRODUCT_STOCK_API,
    // 선택한 주소는 N배송 상품 정보를 확인할 수 없습니다. 도로명 주소로 다시 입력해주세요.
    ReasonType.REJECT_SIX_DIGITS_ZIPCODE_WITH_ARRIVAL_GUARANTEE_PRODUCT,
]

/**
 * 배송지 변경 구매 불가 case
 * 얼럿 후 주문서에서 팅겨나갸야 함
 */
export const DeliveryNotOnSaleReasons: ReasonTypeType[] = [
    // 상품의 배송정보가 변경되었습니다. 상품을 다시 확인하시고 구매해주세요.
    ReasonType.INVALID_CHECK_FULFILLMENT_PRODUCT_STOCK,
    // 상품의 배송정보가 변경되었습니다. 상품을 다시 확인하시고 구매해주세요.
    ReasonType.FAILED_CHECK_PRODUCT_STOCK_DELIVERY_ATTRIBUTE,
    // 상품의 배송정보가 변경되었습니다. 상품을 다시 확인하시고 구매해주세요.
    ReasonType.FAILED_CHECK_PRODUCT_STOCK_OUTBOUND_LOCATION,
    // 상품 정보가 유효하지 않습니다. 상품 정보를 다시 확인해주세요.
    ReasonType.FAILED_CHECK_PRODUCT_STOCK_NOT_FOUND,
]

/** 재고 없음 case */
export const OutOfStockReasons: ReasonTypeType[] = [
    // 재고부족으로 인한 판매불가 상품입니다.
    ReasonType.OUT_OF_STOCK,
    // 옵션 재고가 부족하여 결제가 불가합니다.
    ReasonType.OPTION_OUT_OF_STOCK,
    // 장바구니에 담으시려는 수량보다 상품 재고 수량이 부족합니다
    ReasonType.PRODUCT_STOCK_QUANTITY,
    // 장바구니에 담으시려는 수량보다 상품 재고 수량이 부족합니다.
    ReasonType.OPTION_STOCK_QUANTITY,
    // 장바구니에 담으시려는 수량보다 추가상품 재고 수량이 부족합니다
    ReasonType.SUPPLEMENT_STOCK_QUANTITY,
    // 상품의 재고가 부족합니다.
    ReasonType.REALTIME_PRODUCT_INFO_QUANTITY,
    // 오늘출발 가능수량이 부족합니다.
    ReasonType.TODAY_DISPATCH_STOCK_QUANTITY,
    // 현재 판매되지 않는 추가 상품입니다.
    ReasonType.SUPPLEMENT_STATUS,
    // 현재 판매되지 않는 상품입니다.
    ReasonType.PRODUCT_STATUS,
    // 구매가 불가능한 상품입니다.
    ReasonType.REALTIME_PRODUCT_INFO_STATUS,
    // 존재하지 않는 상품입니다.
    ReasonType.REALTIME_PRODUCT_INFO_FOUND,
    // 가격 이상/재고 부족으로 인해 상품 구매가 불가합니다.
    ReasonType.REALTIME_PRODUCT_INFO,
    // 구매 불가 상품
    ReasonType.FAIL_ERROR,
    // 현재 판매되지 않는 상품 옵션입니다.
    ReasonType.OPTION_STATUS,
]

/** RealtimeProduct 구매 불가 case */
export const RealtimeProductReasons: ReasonTypeType[] = [
    // 실시간 상품 할인 금액을 확인할 수 없습니다.
    ReasonType.REALTIME_PRODUCT_INFO_DISCOUNT_AMOUNT,
    // 상품의 가격 정보가 변경되었습니다.
    ReasonType.REALTIME_PRODUCT_INFO_PRICE,
    // 재고 검사 중 오류가 발생했습니다.
    ReasonType.REALTIME_PRODUCT_INFO_ERROR,
    // 최대 무게/용량을 초과했습니다.
    ReasonType.REALTIME_PRODUCT_INFO_EXCESS_CAPACITY,
]

/** 상품 구매 불가 case */
export const NotOnSaleReasons: ReasonTypeType[] = [
    ReasonType.ORDER_SHEET_ITEM_LIST_CHECK_FAILED,
    // 이 상품의 최대 구매수량을 이미 구매하셨으므로 더 이상 구매하실 수 없습니다.
    ReasonType.EXHAUSTED_USER_PURCHASE_QUANTITY,
    // 1회 최대 구매 가능한 수량을 초과하였습니다. 장바구니에 담겨있는 상품 수량까지 확인해주세요.
    ReasonType.MAX_PURCHASE_QUANTITY,
    // 1회 최소 구매 가능한 수량 미만입니다.
    ReasonType.MIN_PURCHASE_QUANTITY,
    // 1회 최대 구매 가능 건수(100개)를 초과하여 주문이 불가능합니다.
    ReasonType.TOTAL_PURCHASE_LIMIT,
    // ReasonType.MERCHANT_STATUS
    // 상품금액이 변경되었습니다. 상품상세에서 다시 구매해주세요.
    ReasonType.PRODUCT_PRICE,
    // 상품정보가 변경되어 장바구니에 담을 수 없습니다.
    ReasonType.PRODUCT_TYPE,
    ReasonType.ITEM_NOT_FOUND,
    // 옵션정보가 변경되어 장바구니에 담을 수 없습니다.
    ReasonType.OPTION_INFO,
    // 표준구매옵션 변경
    ReasonType.STANDARD_GROUP_PRODUCT,
    // 상품금액이 변경되었습니다. 상품상세에서 다시 구매해주세요.
    ReasonType.OPTION_PRICE,
    // 옵션정보가 변경되어 장바구니에 담을 수 없습니다.
    ReasonType.SUPPLEMENT_INFO,
    // 추가상품 금액이 변경되었습니다. 상품상세에서 다시 구매해주세요.
    ReasonType.SUPPLEMENT_PRICE,
    // 구매 불가 상품
    ReasonType.FAIL_DELIVERY_PLAN,
    // 즉시할인/복수구매할인 정보 변경 구매 불가 상품
    ReasonType.IMMEDIATE_DISCOUNT,
    // 특수할인 정보 변경 구매 불가 상품
    ReasonType.SPECIAL_DISCOUNT,
    // 복수구매 할인의 정보가 변경되었습니다
    ReasonType.MULTI_DISCOUNT,
    /** 1인당 최대 구매수량을 초과하였습니다. */
    ReasonType.EXCESS_USER_PURCHASE_QUANTITY,
    ReasonType.PRODUCT_MULTI_OPTION_TYPE,
    ReasonType.FAIL_RESTRICTED_AREA,
    // 플리마켓 주문이 불가합니다. 플리마켓 주문 정보가 유효한지 확인 후 다시 시도해주세요.
    ReasonType.NOT_PURCHASABLE_FLEAMARKET_PRODUCT,
    // 공동구매 정보 변경
    ReasonType.PRODUCT_GROUP_BUYING_INFO,
    // @ref https://oss.fin.navercorp.com/payOrder/order-qa/issues/5134
    // 최대 무게/용량을 초과했습니다.
    ...RealtimeProductReasons,
]

/** 이미 주문이 완료된 주문 */
export const OrderAlreadyCreatedReasons: ReasonTypeType[] = [
    ReasonType.ORDER_ALREADY_CREATED,
    ReasonType.DUPLICATE_ORDER_SHEET_ID,
]

/** 주문서 재조회 불가 케이스 */
export const ReloadNotAllowedReason: ReasonTypeType[] = [ReasonType.INVALID_PRODUCT_STATUS_ON_ORDER_SHEET_VIEW]

/** 새로고침 case */
export const ReloadReasons: ReasonTypeType[] = [
    ReasonType.EXCEED_CHARGE_POINT_BALANCE_AMOUNT,
    ReasonType.EXCEED_REWARD_POINT_BALANCE_AMOUNT,
    ReasonType.EXCEED_PAY_LATER_AVAILABLE_AMOUNT,
    ReasonType.INVALID_PAY_LATER_WITH_NOT_USE_ALL_POINTS,
    ReasonType.NOT_AGREE_FAMILY_PAY_TERM,
    ReasonType.INVALID_FAMILY_PAY_AVAILABLE,
    ReasonType.INVALID_PRODUCT_FOR_FAMILY_PAY,
    ReasonType.INVALID_FAMILY_PAY_MEMBER_NO,
    ReasonType.EXCEED_FAMILY_PAY_PRE_APPROVAL_PAY_AMOUNT_PER_ORDER,
    ReasonType.EXCEED_FAMILY_PAY_PRE_APPROVAL_PAY_AMOUNT,
    ReasonType.UNAVAILABLE_FAMILY_PAY_PRE_APPROVAL_PAYMENT,
]
